import { GtmSupport } from "@gtm-support/vue2-gtm";
import { AssistPanelEvent, AssistPanelContentType, AssistPanelItemId } from "./events";

export class AssistAnalytics {
  constructor(private readonly gtm: GtmSupport) {}

  /**
   * パネル開閉イベントの発火
   */
  trackPanelOpen() {
    this.trackEvent({
      event: "assist_panel",
      action: "open",
    });
  }

  trackPanelClose() {
    this.trackEvent({
      event: "assist_panel",
      action: "close",
    });
  }

  /**
   * 依頼ボタン送信イベントの発火（コンバージョン計測）
   */
  trackRequestSubmit(
    writerType: string,
    manuscriptCount?: number,
    totalCharacters?: number,
    novelId?: string,
    requestType?: string
  ) {
    this.trackEvent({
      event: "assist_request",
      action: "submit",
      writerType,
      manuscriptCount,
      totalCharacters,
      novelId,
      requestType,
    });
  }

  /**
   * プレミアムボタンクリック時のイベント発火
   */
  trackPremiumButtonClick() {
    this.trackSelectContent({
      contentType: AssistPanelContentType.SubscriptionButton,
      itemId: AssistPanelItemId.Subscription,
    });
  }

  /**
   * select_contentイベントの発火（汎用）
   */
  private trackSelectContent(eventDetails: { contentType: string; itemId: string; contentId?: string }) {
    this.trackEvent({
      event: "select_content",
      contentType: eventDetails.contentType,
      itemId: eventDetails.itemId,
      contentId: eventDetails.contentId,
    } as any);
  }

  /**
   * 汎用イベント発火メソッド（今後の拡張用）
   */
  private trackEvent(eventData: AssistPanelEvent) {
    if (!this.gtm.enabled()) {
      console.info("Google Tag Manager is not enabled.");
      return;
    }

    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];

      // GA4標準に合わせてsnake_caseに変換してpush
      const convertedData: any = { ...eventData };

      // camelCase → snake_case変換
      if ("manuscriptCount" in convertedData) {
        convertedData.manuscript_count = convertedData.manuscriptCount;
        delete convertedData.manuscriptCount;
      }
      if ("totalCharacters" in convertedData) {
        convertedData.total_characters = convertedData.totalCharacters;
        delete convertedData.totalCharacters;
      }
      if ("novelId" in convertedData) {
        convertedData.novel_id = convertedData.novelId;
        delete convertedData.novelId;
      }
      if ("requestType" in convertedData) {
        convertedData.request_type = convertedData.requestType;
        delete convertedData.requestType;
      }
      if ("writerType" in convertedData) {
        convertedData.writer_type = convertedData.writerType;
        delete convertedData.writerType;
      }
      if ("contentType" in convertedData) {
        convertedData.content_type = convertedData.contentType;
        delete convertedData.contentType;
      }
      if ("itemId" in convertedData) {
        convertedData.item_id = convertedData.itemId;
        delete convertedData.itemId;
      }
      if ("contentId" in convertedData) {
        convertedData.content_id = convertedData.contentId;
        delete convertedData.contentId;
      }

      window.dataLayer.push(convertedData);
    }
  }
}

// 明示的なexport
export { AssistAnalytics as default };
